/**
 * Created by fers on 26.09.15.
 */

import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';

export default declareLinkedEntity({
    entity: "viewWithData",
    graphQL: "ViewWithData",
    name: "Views with data",
    userEditable: false,
    dynamoPrefix: 'def',
    storageType: 'schema',
    fields: (types) => {
        return {
            id: {
                name: "Artificial ID (view_id + key + ...)",
                type: "string",
                id: true,
                required: true,
                primaryKey: true,
            },
            view: {
                name: "View",
                type: "relation",
                to: () => types['views'],
                userEditable: false,
                relativeTo: ['screen'],
                inline: true, // this marks that view should be read directly, without DAO
            },
            screen: {
                name: "Screen",
                type: "relation",
                to: () => types['screens'],
                userEditable: false,
                parent: true,
            },
            entityDef: {
                name: "Entity Definition",
                type: "relation",
                to: () => types['entityDefs'],
                userEditable: false,
            },
            cachingRequired: {
                name: "Is Caching Required",
                type: "boolean",
                userEditable: false,
                defaultValue: false,
            },
            invalidQuery: {
                name: "Invalid query",
                type: "boolean",
                userEditable: false,
                defaultValue: false,
            },
            error: {
                name: "Error?",
                type: "boolean",
                userEditable: false,
            },
            errorType: {
                name: "Error Type",
                type: "int",
                userEditable: false,
            },
            parentEmpty: {
                name: "Was parent empty?",
                type: "boolean",
                userEditable: false,
            },
            parentError: {
                name: "Was error in parent?",
                type: "boolean",
                userEditable: false,
            },
            errorDescription: {
                name: "Error description",
                type: "string",
                userEditable: false,
            },
            data: {
                name: "Data",
                type: "object",
                userEditable: false,
            },
            addon: {
                name: "Addon data",
                type: "object",
                userEditable: false,
            }
        };
    },
    relations: (types) => { return {
        cachingRequiredChannels: {
            name: "Applications that should have caching",
            type: 'oneToMany',
            inline: true,
            hasPaging: false,
            export: false,
            to: types['channels'],
            userEditable: false,
        },
        channels: {
            name: "Attached Application",
            type: 'oneToMany',
            inline: true,
            hasPaging: false,
            export: false,
            to: types['channels'],
            userEditable: false,
        },
        channelDefs: {
            name: "Attached Application Definition",
            type: 'oneToMany',
            inline: true,
            hasPaging: false,
            export: false,
            to: types['channelDefs'],
            userEditable: false,
        },
        relations: {
            type: 'oneToMany',
            controllerFn: 'getRelations',
            to: types['viewWithData'],
        }
    }; }
});
